/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import Modal from '../../components/modal/Modal';
import { Button } from '@ui';

const DRIVER_TERMS_PATH = '/contract';

export default function DriverTermsConfirmModal({ open, onClose, onAgree }) {
  const { t } = useTranslation();

  return (
    <Modal modalOpen={open} setModalOpen={nextOpen => !nextOpen && onClose()}>
      <p
        style={{
          fontSize: '18px',
          lineHeight: 1.55,
          marginBottom: '28px',
          color: 'rgba(255, 255, 255, 0.88)',
          textAlign: 'center',
        }}
      >
        <Trans
          i18nKey="driverTermsAccept.popupText"
          components={{
            termsLink: <Link to={DRIVER_TERMS_PATH} style={{ color: '#f94caf', textDecoration: 'underline' }} />,
          }}
        />
      </p>
      <Button onClick={onAgree} className="mainBtn buttonForOfflineStation w-100">
        <span className="mainBtnText">{t('driverTermsAccept.agree')}</span>
      </Button>
    </Modal>
  );
}
